// Per-route head() helper. Each route calls pageMeta({...}) inline so it
// owns its own SEO copy without going through any shared catalog.
export const SITE_URL = import.meta.env.VITE_PUBLIC_SITE_URL ?? "https://pdfisfun.com";

interface PageMetaInput {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  keywords?: string;
}

export function pageMeta({ title, description, path, ogImage, keywords }: PageMetaInput) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = `${title} — pdfisfun`;
  const og = ogImage ?? `${SITE_URL}/og${path}.png`;
  return {
    meta: [
      { title: fullTitle },
      { name: "description", content: description },
      ...(keywords ? [{ name: "keywords", content: keywords }] : []),
      { property: "og:title", content: fullTitle },
      { property: "og:description", content: description },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:image", content: og },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: fullTitle },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}
